module.exports = __webpack_public_path__ + "static/media/icon-event-social.e233245a.svg";